import { MDBBtn, MDBBtnGroup, MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Info.scss";
import Fake from "./../../../assets/images/back/back-blog.png";
import Cosmetic from "./../../../assets/images/icon/makeup-pink.svg";


const Info = (props: InfoProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary
    );

    return <MDBContainer className="info mt-5">
        <MDBRow middle center middle>
            <MDBCol sm="12" md="3">
                <MDBListGroup >
                    <MDBListGroupItem>
                        <h5>{dictionary?.blog?.blog_group}</h5>
                    </MDBListGroupItem>
                    <MDBListGroupItem active className="link">
                        <img src={Cosmetic} alt="" className="icon" />
                        {dictionary?.blog?.jamal}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Cosmetic} alt="" className="icon" />
                        {dictionary?.blog?.medical}
                    </MDBListGroupItem>
                </MDBListGroup>
            </MDBCol>
            <MDBCol className="info-blog" sm="12" md="9">
                <MDBRow middle center>
                    {
                        Array.apply(null, { length: 5 }).map(() =>
                            <MDBCol className="item" xs="12" sm="12" md="8">
                                <picture>
                                    <img src={Fake} />
                                </picture>
                                <MDBRow start middle className="text">
                                    <MDBCol size="9" className="title">
                                        كيف تحافظين على بشرتك
                                    </MDBCol>
                                    <MDBCol size="3" className="group">
                                        جمال
                                    </MDBCol>
                                </MDBRow>
                                <p className="d-block">22 اكتوبر 2020</p>
                            </MDBCol>)
                    }
                </MDBRow>
            </MDBCol>
        </MDBRow>
    </MDBContainer>
};

interface InfoProps { }
export default Info;